export default __webpack_public_path__ + "static/kb_2_3-e850bc92f7f39ec3476f7fe6f5eb9bf9.jpeg";